<div [dir]="_translate.currentLang === 'ar' ? 'rtl' : 'ltr'" class="settings-dialog-container touch-optimized"
  [class.mobile-view]="isMobile" [class.tablet-view]="isTablet" [class.desktop-view]="isDesktop" [@fadeInUp]
  role="dialog" aria-modal="true" [attr.aria-labelledby]="'dialog-title'"
  [attr.aria-describedby]="'dialog-description'">
  <div class="dialog-header compact-header">
    <div class="header-row">
      <div class="header-left">
        <button mat-icon-button class="close-button" (click)="ItemDialogRef.close()"
          [attr.aria-label]="'COMMON.CLOSE' | translate" [matTooltip]="'COMMON.CLOSE' | translate">
          <mat-icon>close</mat-icon>
        </button>
        <h2 mat-dialog-title class="dialog-title" id="dialog-title">
          {{ "COMMON.STORE_SETUP" | translate }}
        </h2>
      </div>
      <div class="header-right">
        <div class="compact-progress" [class.complete]="fullPercentage === 100">
          <div class="progress-ring">
            <mat-spinner [strokeWidth]="3" [diameter]="32" mode="determinate" [value]="fullPercentage"
              [color]="'accent'"></mat-spinner>
            <span class="ring-percentage">{{ fullPercentage }}%</span>
          </div>
          <div class="progress-info">
            <span class="modules-count">{{ getCompletedModules() }}/{{ modulesOfProgress.length }}</span>
            <span class="modules-label">{{ "PROGRESS.MODULES" | translate }}</span>
          </div>
        </div>
        <div class="settings-icon-container">
          <mat-icon class="settings-icon">settings</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-content class="dialog-content">
    <div class="modules-grid">
      <mat-card *ngFor="let module of modulesOfProgress; let moduleIndex = index" class="module-card"
        [class.completed]="module.progressPercentage === 100"
        [class.in-progress]="module.progressPercentage > 0 && module.progressPercentage < 100"
        [class.not-started]="module.progressPercentage === 0">
        <!--        <mat-card-header class="module-header">-->
        <!--          <div mat-card-avatar class="module-avatar">-->
        <!--            <mat-icon [class.completed-icon]="module.progressPercentage === 100">-->
        <!--              {{ getModuleIcon(module.name) }}-->
        <!--            </mat-icon>-->
        <!--          </div>-->
        <!--          <mat-card-title class="module-title">-->
        <!--            {{ "PROGRESS." + module.name | translate }}-->
        <!--          </mat-card-title>-->
        <!--          <mat-card-subtitle style="color: #FFFFFF" class="module-progress-text ">-->
        <!--            {{ getProgressText(module.progressPercentage) }}-->
        <!--          </mat-card-subtitle>-->
        <!--        </mat-card-header>-->

        <mat-card-header class="module-header">
          <div mat-card-avatar class="module-avatar">
            <mat-icon [class.completed-icon]="module.progressPercentage === 100">
              {{ getModuleIcon(module.name) }}
            </mat-icon>
          </div>

          <div class="module-header-content">
            <div class="title-row">
              <mat-card-title class="module-title">
                {{ "PROGRESS." + module.name | translate }}
              </mat-card-title>
              <span class="completion-badge-inline" *ngIf="module.progressPercentage === 100">
                <mat-icon>check_circle</mat-icon>
              </span>
            </div>

            <mat-card-subtitle class="module-progress-text">
              {{ getProgressText(module.progressPercentage) }}
            </mat-card-subtitle>
          </div>
        </mat-card-header>

        <mat-card-content class="module-content">
          <div class="progress-section">
            <div class="progress-info">
              <span class="progress-percentage">{{ module.progressPercentage }}%</span>
              <span class="progress-status">{{ getStatusText(module.progressPercentage) }}</span>
            </div>
            <mat-progress-bar mode="determinate" [value]="module.progressPercentage"
              [color]="getProgressColor(module.progressPercentage)" class="enhanced-progress-bar"></mat-progress-bar>
          </div>

          <mat-expansion-panel class="tasks-panel" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title class="tasks-title">
                <mat-icon>task_alt</mat-icon>
                <span>{{ "PROGRESS.TASKS" | translate }} ({{ getCompletedTasks(module) }}/{{
                  module.progressStages.length }})</span>
              </mat-panel-title>
              <mat-panel-description>
                <mat-icon class="expand-icon">expand_more</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="tasks-list">
              <div *ngFor="let stage of module.progressStages; let i = index" class="task-item"
                [class.completed]="stage.flag" [class.clickable]="!stage.flag"
                [routerLink]="!stage.flag ? module.stagesLinks[i] : null"
                [queryParams]="module.name === 'BRANCHES' && !stage.flag ? { id: branchId } : null"
                (click)="!stage.flag && navigateToTask(module.stagesLinks[i], module.name, $event)">
                <div class="task-content">
                  <div class="task-icon">
                    <mat-icon *ngIf="stage.flag" class="completed-task-icon">check_circle</mat-icon>
                    <mat-icon *ngIf="!stage.flag" class="pending-task-icon">radio_button_unchecked</mat-icon>
                  </div>
                  <div class="task-details">
                    <!--                    <span class="task-name">{{ "PROGRESS." + stage.code | translate }}</span>-->
                    <span class="task-name">{{ "PROGRESS." + stage.code.replace('is', '').toUpperCase() | translate
                      }}</span>
                    <span class="task-status" *ngIf="stage.flag">{{ "PROGRESS.COMPLETED" | translate }}</span>
                    <span class="task-status pending" *ngIf="!stage.flag">{{ "PROGRESS.PENDING" | translate }}</span>
                  </div>
                </div>
                <div class="task-actions">
                  <button mat-stroked-button color="primary" class="action-btn" *ngIf="!stage.flag"
                    (click)="markTaskComplete($event, stage, moduleIndex)">
                    <mat-icon>done</mat-icon>
                    {{ "PROGRESS.MARK_DONE" | translate }}
                  </button>
                  <mat-icon *ngIf="!stage.flag && _translate.currentLang === 'ar'"
                    class="navigate-icon">keyboard_arrow_left</mat-icon>
                  <mat-icon *ngIf="!stage.flag && _translate.currentLang === 'en'"
                    class="navigate-icon">keyboard_arrow_right</mat-icon>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>